// removed by extract-text-webpack-plugin
module.exports = {"smoke":"fill__smoke___2nra2 fill-smoke","smoke--d":"fill__smoke--d___2t1sd fill-smoke--d","smoke--xd":"fill__smoke--xd___2mqKO fill-smoke--xd","silver":"fill__silver___xFGjj fill-silver"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-toolbar/ToolbarButton/style/fill.css
// module id = 254
// module chunks = 0 13